<template>
	<div class="componetself reportList" v-loading="pageLoad">
		<div class="body_btns headbtn">
			<vxe-button type="text" class="tool-btn _icon_button" title="导出" @click="exportData" :loading="exportload"
				:disabled="exportload">
				<i class="iconfont icon-export iconSize "></i>导出
			</vxe-button>
			<el-button type="primary" @click="DoSaveChangeBtn" :loading="DoSaveLoad"
				:disabled="DoDeleteLoad||DoSaveLoad" v-if="FunBtnList['FISSave']">保存</el-button>
			<el-button type="primary" @click="DodeleetChangeBtn" :loading="DoDeleteLoad"
				:disabled="DoDeleteLoad||DoSaveLoad" v-if="FunBtnList['FISDEL']">删除</el-button>
		</div>
		<!-- 报表 -->
		<div class="componet_header">
			<div class="filter">
				<template v-for="(item,index) in  filterList">
					<div class="filter_item" :key="index">
						<c-filter :item="item" :form="filterForm" :line="true" :textMini="45"
							:VailShow="filterShow"></c-filter>
					</div>
				</template>
			</div>
			<div class="btns">
				<el-button type="primary" class="pursh_mainBtn" :loading="selectLog" :disabled="selectLog"
					@click="select">查询</el-button>
			</div>
		</div>
		<div class="componet_body">
			<!-- <div class="body_btns">
				<vxe-button type="text" class="tool-btn _icon_button" title="查看详情" @click="GetASNDeatil"
					:loading="ASNdetailload" :disabled="ASNdetailload">
					<i class="iconfont icon-detail-fill iconSize "></i>查看详情
				</vxe-button>
				<vxe-button type="text" class="tool-btn _icon_button" title="导出" 
					@click="exportData" 
					:loading="exportload" :disabled="exportload">
					<i class="iconfont icon-export iconSize "></i>导出
				</vxe-button>
			</div> -->
			<div class="body_content">
				<!-- checkbox -->
				<!-- <c-table ref="ctablemain" :table="table" :coltype="'seq'" @FitColumns="table.head=$event"
					:cellClass="tableCellClass()" @listenToChild="listenToChild"></c-table> -->

				<c-table ref="table" :coltype="tableType" position="order" :table="table" @select="checkList=$event"
					:cellClass="tableRowClass" :rowClass="tableRowClass" :RowStyle="tableRowStyle" v-loading="loading"
					@changeData="tableChangeData"></c-table>

			</div>
		</div>
	</div>
</template>

<script>
	const Filter = require('./EDIHFilter.js')
	import mix from './minx.js'
	export default {
		props: {
			menuId: {
				type: String,
				default: ''
			},
			label: {
				type: String,
				default: ''
			},
			pageId: {
				type: String,
				default: ''
			}
		},
		mixins: [mix],
		data() {
			return {
				filterForm: {},
				filterList: [],
				selectLog: false,
				// table: {
				// 	pagesize: 100,
				// 	currentPage: 1,
				// 	head: [],
				// 	data: [],
				// 	_height: undefined
				// },
				pageLoad: false,
				exportload: false,
				checkOne: {}
			}
		},
		computed: {
			GetCurrentTab() {
				if (this.menuId == '')
					return {};
				else {
					return this.$store.getters.GetOpenedTabs.find(i => i.menuId == this.menuId);
				}
			},
			userinfo() {
				return this.$store.getters.UserInfo;
			}
		},
		watch: {
			data(newValue, oldValue) {

			}
		},
		methods: {
			changeValue() {
				console.log('更改', this.filterForm)
				this.filterForm = JSON.parse(JSON.stringify(this.filterForm))
			},
			filterShow(filterItem) {
				if (filterItem.allowUser) {
					let users = (filterItem.allowUser || '').split(',');
					let Index = users.findIndex(item => item == this.userinfo.accountType)
					return Index > -1;
				}
				return true;
			},
			listenToChild(e) {
				if (this.menuId == 'GYS_ANSList') {
					if (e && e.rowClick) this.checkOne = e.rowClick;
					else if (e && e.rowdbClick) {
						this.checkOne = e.rowdbClick;
						this.GetASNDeatil();
					}
				}
			},
			//查看ASN详情
			GetASNDeatil() {
				try {
					if (!this.checkOne || JSON.stringify(this.checkOne) == '{}')
						throw '请先选中行';
					this.$tab.openSpecTab('送货单明细页面_查看', 'asnDetail', {
						checkOne: this.checkOne,
						isadd: false
					});
				} catch (e) {
					//TODO handle the exception
					this.$BH().message(e);
				}
			},
			//导出数据
			exportData() {
				try {
					if (this.exportload) return;
					this.exportload = true;
					//梳理数据的
					this.exportDataReq(this.table, () => {
						this.exportload = false;
					});
				} catch (e) {
					this.$BH().message(e);
					this.exportload = false;
				}
			},
			exportDataReq(table, callback) {
				let {
					head,
					data
				} = table;
				let headarr = [];
				head.map(item => {
					if (!item.hide) {
						headarr.push({
							name: item.name,
							title: (item.title || item.name)
						});
					}
				});
				this.$BH().base.http({
					url: 'Web/EXPORTDATATOEXCEL',
					data: {
						head: headarr,
						data: data
					},
					success: (res) => {
						let {
							value
						} = res.data;
						let basestr = res.data.value;
						if (basestr == '') {
							this.$BH().message('返回数据错误');
							callback && callback();
						} else
							this.$BH().DownLoadBase64({
								data: {
									name: this.label + new Date().format('yyyyMMddhhmmss'),
									base64Str: basestr
								},
								loadingcontrol: () => {
									this.exportload = false;
									this.operate = false;
								}
							});
					},
					loadingcontrol: callback
				})
			},
			selectOrder() {
				try {
					this.checkOne = {};
					if (this.selectLog) return;
					this.selectLog = true;
					this.$BH().base.http({
						url: 'Web/GET_REPORT',
						data: {
							filterList: this.filterList,
							filterForm: this.filterForm,
							FuncNumber: this.menuId || '',
							FUser: this.userinfo.pfnumber,
							gysFUser: this.userinfo.fnumber,
							FType: this.userinfo.accountType,
						},
						success: (res) => {
							let {
								data,
								head
							} = res.data.value;
							this.table.data = data;
							//this.table.head = head;
							this.table.head =
								(head || []).filter(item => !item['allowUser'] || item['allowUser'].split(',')
									.findIndex(jitem => jitem == this.userinfo.accountType) > -1);
							if (data.length > 0)
								this.$refs.ctablemain?.updateCoulm();
						},
						loadingcontrol: () => {
							this.selectLog = false;
						}
					})
				} catch (e) {
					//TODO handle the exception
					this.$BH().message(e);
					this.selectLog = false;
				}
			},
			tableCellClass() {
				return ({
					row,
					column,
					rowIndex,
					columnIndex
				}) => {
					let {
						property
					} = column;
					var judycolor = function() {
						if (String(row['_colorDefine']) == 'red')
							return 'table_row_publine_red';
						else if (String(row['_colorDefine']) == 'yellow')
							return 'table_row_publine_yellow';
						else if (String(row['_colorDefine']) == 'blue')
							return 'table_row_publine_blue';
						else return String(row['_colorDefine']);
					}
					judycolor();
				}
			},
		},
		created() {
			// this.filterList=Filter[this.menuId];
			this.initPage();
		}
	}
</script>

<style>
</style>